<template>
  <div class="py-3">
    <h2>適應症</h2>
    <ul class="py-2">
      <li
        v-for="m in mainIndication"
        :key="m.value"
        class="d-flex align-center --cursor"
        @click="pickItem({ group: m.value })"
      >
        <v-chip
          label
          :outline="pick.group !== m.value"
          class="flex-grow-0"
          :color="pick.group === m.value ? 'success' : ''"
          >{{ m.value }}</v-chip
        >
        <p
          class="mb-0 fsz-18"
          :class="{ 'text-primary font-weight-bold': pick.group === m.value }"
        >
          {{ m.text }}
        </p>
      </li>
    </ul>
    <hr />
    <div class="px-4 py-2">
      <p class="mb-0">其他臨床目的施行之大腸鏡</p>
      <span v-if="otherCaptionText" class="text-accent">{{otherCaptionText}}</span>
    </div>
    <ul class="grid-style" :style="
      `grid-template-rows: repeat(${otherIndication.length / styleColumn}, 1fr);
      grid-template-columns: repeat(${styleColumn}, 1fr);`
    ">
      <li
        class="d-flex align-center --cursor mb-2"
        v-for="(o, idx) in otherIndication"
        :key="o.value"
        @click="pickItem({ group: o.group, item: o.value })"
      >
        <v-chip
          label
          :outline="!pick.item.includes(o.value)"
          class="flex-grow-0 bg-warning"
          :color="pick.item.includes(o.value) && idx + 1 <= defaultItemLength ? 'success' : ''"
          >{{ o.group }}{{ o.value }}</v-chip
        >
        <p
          class="mb-0 fsz-18"
          :class="{
            'text-primary font-weight-bold': pick.item.includes(o.value),
          }"
        >
          {{ o.text }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    // indication options
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
    },
    styleColumn: {
      type: Number,
      default: 1,
    },
    otherCaptionText: {
      type: String,
      default: ''
    },
    defaultItemLength: {
      type: Number
    }
  },
  data() {
    return {
      pick: {
        group: null,
        item: [],
      },
      gOther: '9',
    }
  },
  computed: {
    mainIndication() {
      return this.options.filter(
        (indication) => indication.group !== this.gOther
      )
    },
    otherIndication() {
      return this.options.filter(
        (indication) => indication.group === this.gOther
      )
    },
  },
  methods: {
    ...mapActions('examinations', ['updateExaminationColumn']),
    pickItem({ group, item }) {
      this.handleIndication(`${group}${item||''}`)
    },
    handleIndication(arr) {
      this.$emit('change', arr)
    },
    setInit(item) {
      this.pick.group = item.filter((i) => !isNaN(i))[0]
      this.pick.item = item.filter((i) => isNaN(i))
    },
  },
  watch: {
    value(val) {
      this.setInit(val)
    },
  },
  created() {
    this.setInit(this.value)
  },
}
</script>

<style>
.grid-style {
  display: grid;
  grid-auto-flow: column;
}
</style>
